import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";

import { FilledButton, VerticalGap } from "../component";

const LoginScreen = () => {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    const data = {
      id,
      password,
    };

    if (!data.id || !data.password) {
      alert("아이디와 비밀번호를 입력해주세요");
      return;
    }

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/login`, data)
      .then((res) => {
        console.log(res.data);
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        window.location.href = "/";
      })
      .catch((err) => {
        console.log(err.response);
        if (err.response.status === 400) {
          alert("아이디 또는 비밀번호가 일치하지 않습니다");
        } else {
          alert("로그인 중 오류가 발생했습니다");
        }
      });
  };

  return (
    <LoginLayout>
      <LoginBackground>
        <LoginTitle>
          <span className="navy">KRPT</span>
          &nbsp; 안전문서 등록 시스템
        </LoginTitle>
        <VerticalGap height="2px" />
        <LoginForm>
          <LoginInput
            type="text"
            placeholder="아이디"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <LoginInput
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <VerticalGap height="2px" />
          <FilledButton
            style={{ width: "100%" }}
            type="submit"
            onClick={handleLogin}
          >
            로그인
          </FilledButton>

          <img src={require("../assets/logo.png")} alt="logo" width={100} />
        </LoginForm>
      </LoginBackground>
    </LoginLayout>
  );
};

const LoginLayout = styled.div`
  height: auto;
  min-height: 100vh;
  max-width: 1300px;
  width: 90%;
  min-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-white);
`;

const LoginBackground = styled.div`
  background-color: var(--color-background);
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const LoginTitle = styled.div`
  color: var(--color-black);
  font-size: var(--font-size-title);
  font-weight: bold;
  margin-bottom: 10px;

  .navy {
    color: var(--color-main);
  }
`;

const LoginForm = styled.form`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const LoginInput = styled.input`
  padding: 0 10px;
  width: 278px;
  height: 30px;
  border: 1px solid var(--color-main);

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: var(--color-gray);
  }
`;

export default LoginScreen;
